// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","450":"react-apexcharts","453":"component---src-pages-404-tsx","879":"9adb6eba"}[chunkId] + "-" + {"223":"3d6b8173f5cdd28d81f0","245":"8411dab490421ff2266a","450":"d98c5db68b9f4e7210fa","453":"3a5b196cb9ebbe569058","879":"7178f0b1650f3c149d14"}[chunkId] + ".js";
};